const styles = () => ({
  formControlLabel: {
    color: '#002855',
    marginLeft: '24px',
  },
});

export default styles;
